export const normalizeFetchLayerPatternsResponse = response =>
    response.map(pattern => ({
        id: pattern.motif_id,
        name: pattern.motif_caption,
        feedback: pattern.feedback,
        description: pattern.description,
        grade: pattern.grade,
        query: pattern.query,
        type: pattern.type,
        method: pattern.method,
        groupingCap: pattern.grouping_cap,
        isFlaky: pattern.is_flaky,
        colorId: pattern.color_id,
        llmVersion: pattern.lbe_data?.gpt_version,
    }))
